export const formdata = {
    email: '',
    zip: '',
    salutation: '',
    name: '',
    lastname: '',
    firm: '',
    tel: '',
    optIn: null
};